<template>
  <v-menu
    v-model="timeMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
    v-bind="$attrs"
    :key="maskKey"
  >
    <template v-slot:activator="{ on }">
      <MaskedTextField
        :inputData.sync="maskedModelTime"
        mask-type="time"
        :label="label"
        v-bind="$attrs"
        @update:inputData="setModelTime"
        @blur="lostFocus"
      >
        <template slot="prependMask">
          <v-icon v-on="on">mdi-clock-outline</v-icon>
        </template>

        <template v-if="hasNowButton" slot="appendMask">
          <v-icon @click="setNow">mdi-bookmark</v-icon>
        </template>
      </MaskedTextField>

      <!-- <v-text-field
        :value="modelTime | formatDate"
        :label="label"
        
        v-bind="$attrs"
      >
        <template v-slot:prepend>
          <v-icon v-on="on">mdi-calendar</v-icon>
        </template>
      </v-text-field> -->
    </template>
    <v-time-picker 
      v-model="modelTime"
      @change="change"
      format="24hr"
    />
  </v-menu>
</template>

<script>
import moment from "moment";
import MaskedTextField from "@shared_components/masked_text_field.vue"

 export default {
  data () {
   return { 
     timeMenu: false,
     modelTime: null,
     maskedModelTime: null,
     maskKey: 1
   }
  },
  components: {
    MaskedTextField: MaskedTextField,
  },
  props: {
    inputData: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "Hora"
    },
    hasNowTime: {
      type: Boolean,
      default: false
    },
    hasNowButton: {
      type: Boolean,
      default: false
    }
  },
  created() {
    moment.locale("pt-br"); 
    // console.log(this.inputData, moment(new Date(this.inputData)).format('LT'));
    if (this.hasNowTime && !this.inputData) {
      this.modelTime = moment().format('LT');
      this.change();
    } else {
      this.modelTime = this.inputData;
    }
    this.maskedModelTime = this.modelTime; //moment(this.modelTime).format("H:mm");
  },
  methods: {
    change: function () {
      this.timeMenu = false;
      this.maskedModelTime = this.modelTime; //moment(this.modelTime).format("H:mm");
      this.emitTimeChange();
      this.maskKey++;
    },
    setModelTime: function() {
      if (this.maskedModelTime.length == 5){
        this.modelTime = this.maskedModelTime; //moment(this.maskedModelTime, "H:mm").format("H:mm");
        this.emitTimeChange();
      }
    },
    emitTimeChange: function() {
      this.$emit('update:inputData', this.modelTime);
    },
    lostFocus: function(){
      if (this.maskedModelTime.length < 5){
        this.maskedModelTime = "";
        this.modelTime = null;
        this.emitTimeChange();
      }
    },
    setNow: function() {
      this.modelTime = moment().format('LT');
      this.change();
    }
  },
  // computed: {
  //   computedStartDateFormatted() {
  //     return this.startDate ? moment(this.startDate).format("DD/MM/YYYY") : "";
  //   },
  //   computedEndDateFormatted() {
  //     return this.endDate ? moment(this.endDate).format("DD/MM/YYYY") : "";
  //   }
  // }
 }
</script>

<style scoped>
</style>
